module.exports = __webpack_public_path__ + "img/logofang.fcf12087.png";